import { TooltipWrapper } from '@va/ui/tooltips';
import { PropsWithChildren } from 'react';
import { ProvisioningSteps, ProvisioningStepsParams } from './ProvisioningSteps';

export const ProvisioningStepsTooltip = ({
  steps,
  currentStepVal,
  status,
  children,
}: PropsWithChildren<ProvisioningStepsParams>) => {
  return (
    <TooltipWrapper
      interactive
      tooltipClassNames='shadow-overlay rounded-12'
      useDefaultStyle={false}
      content={
        <div className='bg-white rounded-12 p-1'>
          <ProvisioningSteps steps={steps} status={status} currentStepVal={currentStepVal} />
        </div>
      }
    >
      <div>{children}</div>
    </TooltipWrapper>
  );
};
